import axios from 'axios'
import nprogress from 'nprogress'
import { Message } from 'element-ui'
// huoxt S
const request = axios.create({
    baseURL: 'http://8.145.39.155/salewebapi',
})

// huoxt E
request.interceptors.request.use(
    function (config) {
        nprogress.start()
        // if (window.localStorage.getItem('Authorization')) {
        //     // let tokeninfo = JSON.parse(sessionStorage.getItem('token'));
        //     // let token = tokeninfo.usertoken.token
        //     // let scrite = tokeninfo.usertoken.token_type
        //     //  
        //     config.headers['Authorization'] = 'Bearer' + ' ' + window.localStorage.getItem('Authorization')

        //     // huoxt S
        //     if (config.url == '/YJT/UploadYJTImg') {
        //         config.headers['Accept'] = 'application/json'
        //         config.headers['Content-Type'] = 'multipart/form-data'
        //         const formData = new FormData()
        //         formData.append('file', config.data.file, 'test.jpg')
        //         formData.append('TenantID', config.data.CompanyId)
        //         formData.append('CompanyId', config.data.CompanyId)
        //         formData.append('lsh', config.data.lsh)
        //         formData.append('formList', config.data.formList)
        //         config.data = formData
        //     }
        //     // huoxt E
        // }
        return config // config
    },
    function (error) {
        //请求错误时做些事
        return Promise.reject(error)
    }
)
// const loadingInstance = Loading.service({ fullscreen: true });
request.interceptors.response.use(
    function (response) {
        nprogress.done()
        
        return response
    },
    function (error) {
        nprogress.done()
        if (error.response) {
            Message.error(`请求错误，状态码：${error.response.status}`)
        } else if (error.request) {
            Message.error('未收到服务器响应，请检查网络连接')
        } else {
            Message.error('请求配置错误')
        }
        //请求错误时做些事
        return Promise.reject(error)
    }
)
export function get(url, params) {
    return request.get(url, { params })
}
export function post(url, data) {
    return request.post(url, data)
}
export default request
